import React, { useState, useEffect } from 'react'

export default function Radar({ centerX = 350, centerY = 420, radius = 300, data, dataKey, stroke, fill, fillOpacity }) {
    //   const [lines, setLines] = useState([]); 

    const printPolygon = (r) => {
        let tmpObjects = [];
        let tmpLines = [];
        let tmpPoints = [];
        for (let i = 0; i < data.length; i++) {
            const angle = (i) * (Math.PI * 2) / data.length;

            const dist = r / data[i].max * data[i][dataKey];
            var x1 = centerX + Math.cos(angle) * (dist);
            var y1 = centerY + Math.sin(angle) * (dist);
            var x2 = centerX + Math.cos(angle)
            var y2 = centerY + Math.sin(angle)

            tmpPoints.push({ x: x1, y: y1 })

            // tmpLines.push(<circle onMouseOver={()=>{document.getElementById(dpLabelID).style.display='block'}} onMouseOut={()=>{document.getElementById(dpLabelID).style.display='none'}}  key={i+x1+x2+y1+y2} cx={x1} cy={y1} r={5}  strokeWidth={2} stroke= {data[i].color} fill={ data[i].color}/>)
            tmpLines.push(<circle key={i + x1 + x2 + y1 + y2} cx={x1} cy={y1} r={5} strokeWidth={2} stroke={data[i].color} fill={data[i].color} />)

            //vast label
            tmpLines.push(<text style={{ display: 'block' }} className="charting-datapointlabel" key={"dplable" + i + x1 + x2 + y1 + y2} x={x1 + 10} y={y1 + 20} fill={"black"}>{data[i][dataKey]}%</text>)


            //hover label
            //    let dpLabelID = "dpl"+i+x1+x2+y1+y2;
            //    tmpLines.push(<text id={dpLabelID} style={{display:'none'}} className="charting-datapointlabel" key={"dpl"+i+x1+x2+y1+y2} x={centerX} y={centerY -10} fill={"black"}>{data[i][dataKey]} %</text>)
        }
        let points = tmpPoints.map(point => { return point.x + ',' + point.y }).join(',')
        tmpObjects.push(<polygon key={'radar'} points={points} style={{ fill: fill, stroke: stroke, strokeWidth: 1, opacity: fillOpacity }} ></polygon>)
        tmpObjects.push(...tmpLines);

        return tmpObjects
    }

    return (<>
        {printPolygon(radius)}
    </>)
}
